var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar" },
    [
      _c(
        "nav",
        { staticClass: "sidebar-nav" },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "nav" },
            [
              _vm._l(_vm.navItems, function(item, index) {
                return _vm.$auth.check(item.role)
                  ? [
                      item.title
                        ? [
                            _c("SidebarNavTitle", {
                              attrs: {
                                name: _vm.$t(item.name),
                                classes: item.class,
                                wrapper: item.wrapper
                              }
                            })
                          ]
                        : item.divider
                        ? [
                            _c("SidebarNavDivider", {
                              attrs: { classes: item.class }
                            })
                          ]
                        : [
                            item.children
                              ? [
                                  _vm.$auth.check(item.role)
                                    ? _c(
                                        "SidebarNavDropdown",
                                        {
                                          attrs: {
                                            name: _vm.$t(item.name),
                                            url: item.url,
                                            icon: item.icon
                                          }
                                        },
                                        [
                                          _vm._l(item.children, function(
                                            childL1,
                                            index
                                          ) {
                                            return [
                                              childL1.children
                                                ? [
                                                    _c(
                                                      "SidebarNavDropdown",
                                                      {
                                                        attrs: {
                                                          name: _vm.$t(
                                                            childL1.name
                                                          ),
                                                          url: childL1.url,
                                                          icon: childL1.icon
                                                        }
                                                      },
                                                      _vm._l(
                                                        childL1.children,
                                                        function(
                                                          childL2,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              staticClass:
                                                                "nav-item"
                                                            },
                                                            [
                                                              _c(
                                                                "SidebarNavLink",
                                                                {
                                                                  attrs: {
                                                                    name: _vm.$t(
                                                                      childL2.name
                                                                    ),
                                                                    url:
                                                                      childL2.url,
                                                                    icon:
                                                                      childL2.icon,
                                                                    badge:
                                                                      childL2.badge,
                                                                    variant:
                                                                      item.variant
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      )
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "SidebarNavItem",
                                                      {
                                                        attrs: {
                                                          classes: item.class
                                                        }
                                                      },
                                                      [
                                                        _c("SidebarNavLink", {
                                                          attrs: {
                                                            name: _vm.$t(
                                                              childL1.name
                                                            ),
                                                            url: childL1.url,
                                                            icon: childL1.icon,
                                                            badge:
                                                              childL1.badge,
                                                            variant:
                                                              item.variant
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              : [
                                  _c(
                                    "SidebarNavItem",
                                    { attrs: { classes: item.class } },
                                    [
                                      _vm.$auth.check(item.role)
                                        ? _c("SidebarNavLink", {
                                            attrs: {
                                              name: _vm.$t(item.name),
                                              url: item.url,
                                              icon: item.icon,
                                              badge: item.badge,
                                              variant: item.variant
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                          ]
                    ]
                  : _vm._e()
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _c("SidebarMinimizer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60ef2d09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ef2d09","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/Sidebar.vue
// module id = 1139
// module chunks = 0